import { pageDe, pageEn, pageHr } from "./updateProfilePageTranslations";

export const updateProfileTranslations = {
  en: {
    page: pageEn,
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    saving: "Saving...",
    profile_updated_successfully: "Profile updated successfully",
    close: "Close",

    tabs: {
      basic: "BASIC INFO",
      fighter: "FIGHTER INFO",
      manager: "MANAGER INFO",
      socialMedia: "SOCIAL MEDIA",
      youtube: "YOUTUBE",
      history: "FIGHT HISTORY",
      achievement: "ACHIEVEMENTS",
      videoUpload: "VIDEO UPLOAD",
      sponsorships: "SPONSORSHIP",
    },

    basicInfo: {
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      nationality: "Nationality",
      nationalityTooltip:
        "Enter the country that represents your nationality or citizenship. This helps organizers understand your background and may influence eligibility or matchmaking.",
      nationalityPlaceholder: "Select nationality",
      residenceCountry: "Country",
      residenceCountryTooltip:
        "Select the country where you currently live or are based. This helps with regional matchmaking, travel planning, and location-based searches.",
      residenceCountryPlaceholder: "Select country",
      profileImage: "Profile Image",
      profileImageAlt: "Profile",
      profileImagePreviewAlt: "Preview",
      bio: "Bio",
      bioTooltip:
        "Enter your fighting nickname or stage name — if you use one. This name may appear on your public profile, fight cards, or promotional materials.",
    },
    managerInfoSection: {
      managerType: "Manager Type",
      managerTypePlaceholder: "Select manager type",
      managerTypeOptions: {
        Individual: "Individual",
        Agency: "Agency",
      },
      organizationName: "Organization Name",
    },
    fighterInfoSection: {
      nickname: "Nickname",
      nicknameTooltip:
        "Enter your fight name or stage name — if you use one. This name may appear on your public profile, fight cards, or promotional materials.",
      dob: "Date of Birth",
      stance: "Stance",
      stancePlaceholder: "Select stance",
      height: "Height",
      weight: "Weight",
      reach: "Reach",
      unit: "Unit",
      unitOptions: {
        cm: "cm",
        ft: "ft",
        inch: "inch",
        kgs: "kg",
        lbs: "lbs",
      },
      team: "Team",
      teamTooltip:
        "Enter the name of the team, camp, or affiliation you represent. This connects you with your training network and increases the visibility of your background.",
      gym: "Gym",
      weightClassesPlaceholder: "Select weightclasses",
      gymTooltip:
        "Enter the name of the gym or training center where you currently train. This adds credibility to your profile and helps others understand your training environment.",
      titleHolder: "Title Holder",
      orthodox: "Orthodox",
      southpaw: "Southpaw",
      switch: "Switch",
      trainingDisciplines: "Training Disciplines",
      trainingDisciplinesTooltip:
        "Select all martial arts or disciplines you actively train in or compete in. This helps match you with the right opportunities and makes your profile more discoverable.",
      weightClasses: "Weight Classes",
      trainingDisciplinesPlaceholder: "Select trainingDisciplines",
      weightClassesTooltip:
        "Select the weight class you currently compete in or intend to compete in. This is essential for matchmaking, filtering, and event planning.",
      fightStyleDescription: "Fight Style Description",
      fightStyleDescriptionTooltip:
        "Briefly describe your fighting style, strengths, and preferred tactics. This gives managers and matchmakers a better understanding of how you fight.",
    },

    youtubeSection: {
      linkLabel: "YouTube Link",
      linkPlaceholder: "e.g., https://youtube.com/watch?v=example",
      titleLabel: "Short Title",
      titlePlaceholder: "e.g., Fight Highlights",
      descriptionLabel: "Short Description",
      descriptionPlaceholder: "e.g., Highlights from my latest fight",
      removeButton: "Remove Link",
      addButton: "Add YouTube Link",
      tooltip:
        "Add links to your fight footage, highlight reels, or intro videos. These help promote your style, skills, and experience to potential partners or promoters.",
    },

    fightHistorySection: {
      title: "Fight History",
      subtitle: "Manage your fight history",
      removeButton: "Remove Fight",
      tooltip:
        "Add details of your past fights, including opponent, date, outcome, and location. This helps showcase your experience and performance history to promoters and matchmakers.",
    },

    achievementsSection: {
      achievementLabel: "Achievement {{index}}",
      achievementPlaceholder: "e.g., World Champion 2022",
      removeButton: "Remove",
      addButton: "Add Achievement",
      tooltip:
        "List your most important titles, medals, or career highlights. This helps build your reputation and shows what you’ve accomplished in combat sports.",
    },

    videoUploadSection: {
      title: "Video Upload",
      subtitle: "Upload a video to showcase your skills",
      currentVideo: "Current Video",
      removeButton: "Remove Video",
      uploadLabel: "Upload a video",
      supportedFormats: "Supported formats: MP4, MOV",
    },
    sponsorshipsSection: {
      title: "Sponsorships",
      subtitle: "Showcase your sponsors",
      nameLabel: "Sponsor Name",
      descriptionLabel: "Sponsor Description",
      linkLabel: "Sponsor Website",
      logoLabel: "Sponsor Logo",
      namePlaceholder: "Sponsor Name",
      descriptionPlaceholder: "Sponsor Description",
      linkPlaceholder: "Sponsor Link",
      uploadLogo: "Upload Logo",
      uploading: "Uploading...",
      noSponsorships: "No sponsorships added yet",
      addButton: "Add New Sponsor",
      removeButton: "Remove",
      chooseFile: "Choose file",
    },
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      residenceCountryRequired: "Residence country is required",
      nationalityRequired: "Nationality is required",
      phoneDigits: "Phone number must contain only digits",
      phoneLength: "Phone number must be between 10 and 16 digits",
      bioLength: "Bio must be 2000 characters or less",
      heightRange: "Height must be between {{min}} and {{max}} {{unit}}",
      weightRange: "Weight must be between {{min}} and {{max}} {{unit}}",
      reachRange: "Reach must be between {{min}} and {{max}} {{unit}}",
      videoFormat: "Only MP4 and MOV video formats are supported",
      invalidUrl: "Invalid URL",
      youtubeDescriptionLength: "Description must be 200 characters or less",
      opponentNameLength: "Opponent name must be 25 characters or less",
      fightDateRequired: "Date is required",
      fightLocationRequired: "Location is required",
      fightResultRequired: "Result is required",
      roundNegative: "Round cannot be negative",
      typeOfEndingRequired: "Type of ending is required",
      achievementLength: "Achievement must be 5000 characters or less",
      sponsorNameLength: "Sponsor name must be 50 characters or less",
      sponsorDescriptionLength: "Description must be 500 characters or less",
      sponsorNameRequired: "Sponsor name is required",
      socialMediaUrlRequired: "URL is required",
      socialMediaTypeRequired: "Social media type is required",
      invalidSocialMediaUrl: "URL must start with http:// or https://",
      socialMediaTypeUsed: "{{type}} is already used",
      formErrors: "Please correct the errors in the form.",
    },
  },

  de: {
    page: pageDe,
    editProfile: "Profil bearbeiten",
    saveChanges: "Änderungen speichern",
    saving: "Speichern...",
    profile_updated_successfully: "Profil erfolgreich aktualisiert",
    close: "Schließen",

    tabs: {
      basic: "GRUNDINFORMATIONEN",
      fighter: "KÄMPFERINFORMATIONEN",
      manager: "MANAGERINFORMATIONEN",
      socialMedia: "SOZIALE MEDIEN",
      youtube: "YOUTUBE",
      history: "KAMPFHISTORIE",
      achievement: "ERFOLGE",
      videoUpload: "VIDEO HOCHLADEN",
      sponsorships: "SPONSORING",
    },

    basicInfo: {
      firstName: "Vorname",
      lastName: "Nachname",
      phone: "Telefon",
      nationality: "Nationalität",
      nationalityTooltip:
        "Geben Sie das Land an, das Ihre Nationalität oder Staatsbürgerschaft darstellt. Dies hilft den Organisatoren, Ihren Hintergrund zu verstehen und kann die Teilnahmeberechtigung oder das Matchmaking beeinflussen.",
      nationalityPlaceholder: "Nationalität auswählen",
      residenceCountry: "Land",
      residenceCountryTooltip:
        "Wählen Sie das Land aus, in dem Sie derzeit leben oder ansässig sind. Dies hilft bei regionalem Matchmaking, Reiseplanung und standortbasierten Suchen.",
      residenceCountryPlaceholder: "Land auswählen",
      profileImage: "Profilbild",
      profileImageAlt: "Profil",
      profileImagePreviewAlt: "Vorschau",
      bio: "Biografie",
      bioTooltip:
        "Geben Sie Ihren Kampfnamen oder Künstlernamen ein — falls Sie einen verwenden. Dieser Name kann auf Ihrem öffentlichen Profil, auf Fight Cards oder Werbematerialien erscheinen.",
    },
    managerInfoSection: {
      managerType: "Manager-Typ",
      managerTypePlaceholder: "Manager-Typ auswählen",
      managerTypeOptions: {
        Individual: "Einzeln",
        Agency: "Agentur",
      },
      organizationName: "Name der Organisation",
    },
    fighterInfoSection: {
      nickname: "Spitzname",
      nicknameTooltip:
        "Geben Sie Ihren Kampfnamen oder Künstlernamen ein — falls Sie einen verwenden. Dieser Name kann auf Ihrem öffentlichen Profil, auf Fight Cards oder Werbematerialien erscheinen.",
      dob: "Geburtsdatum",
      stance: "Stellung",
      stancePlaceholder: "Stellung auswählen",
      height: "Größe",
      orthodox: "Orthodox",
      southpaw: "Linksauslage",
      switch: "Switch-Hitter",
      weight: "Gewicht",
      reach: "Reichweite",
      unit: "Einheit",
      unitOptions: {
        cm: "cm",
        ft: "ft",
        inch: "inch",
        kgs: "kg",
        lbs: "lbs",
      },
      team: "Team",
      trainingDisciplinesPlaceholder: "Trainingsdisziplinen auswählen",
      weightClassesPlaceholder: "Gewichtsklassen auswählen",
      teamTooltip:
        "Geben Sie den Namen des Teams, Camps oder der Zugehörigkeit ein, die Sie vertreten. Dies verbindet Sie mit Ihrem Trainingsnetzwerk und erhöht die Sichtbarkeit Ihres Hintergrunds.",
      gym: "Fitnessstudio",
      gymTooltip:
        "Geben Sie den Namen des Fitnessstudios oder Trainingszentrums ein, in dem Sie derzeit trainieren. Dies erhöht die Glaubwürdigkeit Ihres Profils und hilft anderen, Ihre Trainingsumgebung zu verstehen.",
      titleHolder: "Titelträger",
      trainingDisciplines: "Trainingsdisziplinen",
      trainingDisciplinesTooltip:
        "Wählen Sie alle Kampfsportarten oder Disziplinen aus, die Sie aktiv trainieren oder in denen Sie antreten. Dies hilft, passende Möglichkeiten zu finden und macht Ihr Profil besser auffindbar.",
      weightClasses: "Gewichtsklassen",
      weightClassesTooltip:
        "Wählen Sie die Gewichtsklasse aus, in der Sie derzeit antreten oder antreten möchten. Dies ist entscheidend für Matchmaking, Filterung und Veranstaltungsplanung.",
      fightStyleDescription: "Kampfstil-Beschreibung",
      fightStyleDescriptionTooltip:
        "Beschreiben Sie kurz Ihren Kampfstil, Ihre Stärken und bevorzugten Taktiken. Dies gibt Managern und Matchmakern ein besseres Gefühl dafür, wie Sie kämpfen.",
    },

    youtubeSection: {
      linkLabel: "YouTube-Link",
      linkPlaceholder: "z. B. https://youtube.com/watch?v=example",
      titleLabel: "Kurztitel",
      titlePlaceholder: "z. B. Kampf-Highlights",
      descriptionLabel: "Kurzbeschreibung",
      descriptionPlaceholder: "z. B. Highlights aus meinem letzten Kampf",
      removeButton: "Link entfernen",
      addButton: "YouTube-Link hinzufügen",
      tooltip:
        "Fügen Sie Links zu Ihren Kampfvideos, Highlight-Reels oder Intro-Videos hinzu. Diese helfen, Ihren Stil, Ihre Fähigkeiten und Ihre Erfahrung potenziellen Partnern oder Promotern zu präsentieren.",
    },

    fightHistorySection: {
      title: "Kampfhistorie",
      subtitle: "Verwalten Sie Ihre Kampfhistorie",
      removeButton: "Kampf entfernen",
      tooltip:
        "Fügen Sie Details Ihrer vergangenen Kämpfe hinzu, einschließlich Gegner, Datum, Ergebnis und Ort. Dies hilft, Ihre Erfahrung und Leistungshistorie gegenüber Promotern und Matchmakern zu präsentieren.",
    },

    achievementsSection: {
      achievementLabel: "Erfolg {{index}}",
      achievementPlaceholder: "z. B. Weltmeister 2022",
      removeButton: "Entfernen",
      addButton: "Erfolg hinzufügen",
      tooltip:
        "Listen Sie Ihre wichtigsten Titel, Medaillen oder Karriere-Highlights auf. Dies hilft, Ihren Ruf aufzubauen und zeigt, was Sie im Kampfsport erreicht haben.",
    },

    videoUploadSection: {
      title: "Video Hochladen",
      subtitle: "Laden Sie ein Video hoch, um Ihre Fähigkeiten zu präsentieren",
      currentVideo: "Aktuelles Video",
      removeButton: "Video entfernen",
      uploadLabel: "Video hochladen",
      supportedFormats: "Unterstützte Formate: MP4, MOV",
    },

    sponsorshipsSection: {
      title: "Sponsoring",
      subtitle: "Präsentieren Sie Ihre Sponsoren",
      nameLabel: "Name des Sponsors",
      descriptionLabel: "Beschreibung des Sponsors",
      linkLabel: "Webseite des Sponsors",
      logoLabel: "Sponsor-Logo",
      namePlaceholder: "Sponsorname",
      descriptionPlaceholder: "Sponsorenbeschreibung",
      linkPlaceholder: "Sponsorlink",
      uploadLogo: "Logo hochladen",
      uploading: "Wird hochgeladen...",
      noSponsorships: "Noch keine Sponsoren hinzugefügt",
      addButton: "Neuen Sponsor hinzufügen",
      removeButton: "Entfernen",
      chooseFile: "Datei auswählen",
    },

    validation: {
      firstNameRequired: "Vorname ist erforderlich",
      lastNameRequired: "Nachname ist erforderlich",
      residenceCountryRequired: "Wohnsitzland ist erforderlich",
      nationalityRequired: "Nationalität ist erforderlich",
      phoneDigits: "Telefonnummer darf nur Ziffern enthalten",
      phoneLength: "Telefonnummer muss zwischen 10 und 16 Ziffern lang sein",
      bioLength: "Biografie darf maximal 2000 Zeichen lang sein",
      heightRange: "Größe muss zwischen {{min}} und {{max}} {{unit}} liegen",
      weightRange: "Gewicht muss zwischen {{min}} und {{max}} {{unit}} liegen",
      reachRange:
        "Reichweite muss zwischen {{min}} und {{max}} {{unit}} liegen",
      videoFormat: "Nur MP4- und MOV-Videoformate werden unterstützt",
      invalidUrl: "Ungültige URL",
      youtubeDescriptionLength:
        "Beschreibung darf maximal 200 Zeichen lang sein",
      opponentNameLength: "Name des Gegners darf maximal 25 Zeichen lang sein",
      fightDateRequired: "Datum ist erforderlich",
      fightLocationRequired: "Ort ist erforderlich",
      fightResultRequired: "Ergebnis ist erforderlich",
      roundNegative: "Runde darf nicht negativ sein",
      typeOfEndingRequired: "Art des Abschlusses ist erforderlich",
      achievementLength: "Erfolg darf maximal 5000 Zeichen lang sein",
      sponsorNameLength: "Sponsorname darf maximal 50 Zeichen lang sein",
      sponsorDescriptionLength:
        "Beschreibung darf maximal 500 Zeichen lang sein",
      sponsorNameRequired: "Sponsorname ist erforderlich",
      socialMediaUrlRequired: "URL ist erforderlich",
      socialMediaTypeRequired: "Social-Media-Typ ist erforderlich",
      invalidSocialMediaUrl: "URL muss mit http:// oder https:// beginnen",
      socialMediaTypeUsed: "{{type}} wird bereits verwendet",
      formErrors: "Bitte korrigieren Sie die Fehler im Formular.",
    },
  },

  hr: {
    page: pageHr,
    editProfile: "Uredi profil",
    saveChanges: "Spremi promjene",
    saving: "Spremanje...",
    profile_updated_successfully: "Profil je uspješno ažuriran",
    close: "Zatvori",

    tabs: {
      basic: "OSNOVNE INFORMACIJE",
      fighter: "INFORMACIJE O BORCU",
      manager: "INFORMACIJE O MENADŽERU",
      socialMedia: "DRUŠTVENI MEDIJI",
      youtube: "YOUTUBE",
      history: "POVIJEST BORBI",
      achievement: "POSTIGNUĆA",
      videoUpload: "UPLOAD VIDEA",
      sponsorships: "SPONZORSTVO",
    },

    basicInfo: {
      firstName: "Ime",
      lastName: "Prezime",
      phone: "Telefon",
      nationality: "Nacionalnost",
      nationalityTooltip:
        "Unesite državu koja predstavlja vašu nacionalnost ili državljanstvo. To pomaže organizatorima da razumiju vaše porijeklo i može utjecati na podobnost ili uparivanje.",
      nationalityPlaceholder: "Odaberite nacionalnost",
      residenceCountry: "Država",
      residenceCountryTooltip:
        "Odaberite državu u kojoj trenutno živite ili boravite. To pomaže kod regionalnog uparivanja, planiranja putovanja i pretraživanja po lokaciji.",
      residenceCountryPlaceholder: "Odaberite državu",
      profileImage: "Profilna slika",
      profileImageAlt: "Profil",
      profileImagePreviewAlt: "Pregled",
      bio: "Biografija",
      bioTooltip:
        "Unesite svoj borilački nadimak ili umjetničko ime — ako ga koristite. Ovo ime može se pojaviti na vašem javnom profilu, borbenim karticama ili promotivnim materijalima.",
    },

    managerInfoSection: {
      managerType: "Tip menadžera",
      managerTypePlaceholder: "Odaberite tip menadžera",
      managerTypeOptions: {
        Individual: "Pojedinac",
        Agency: "Agencija",
      },
      organizationName: "Naziv organizacije",
    },

    fighterInfoSection: {
      nickname: "Nadimak",
      nicknameTooltip:
        "Unesite svoj borilački nadimak ili umjetničko ime — ako ga koristite. Ovo ime može se pojaviti na vašem javnom profilu, borbenim karticama ili promotivnim materijalima.",
      dob: "Datum rođenja",
      stance: "Stav",
      stancePlaceholder: "Odaberite stav",
      height: "Visina",
      weight: "Težina",
      reach: "Dohvat",
      unit: "Jedinica",
      unitOptions: {
        cm: "cm",
        ft: "ft",
        inch: "inch",
        kgs: "kg",
        lbs: "lbs",
      },
      weightClassesPlaceholder: "Odaberite kategorije težine",
      trainingDisciplinesPlaceholder: "Odaberite sportske discipline",
      team: "Tim",
      orthodox: "Ortodoks",
      southpaw: "Lijeva gard",
      switch: "Prebacivač",
      teamTooltip:
        "Unesite naziv tima, borilačkog kampa ili pripadnosti koju predstavljate. To vas povezuje s vašom trenažnom mrežom i daje vidljivost vašoj pozadini.",
      gym: "Dvorana",
      gymTooltip:
        "Unesite naziv dvorane ili trenažnog centra u kojem trenutno trenirate. Ovo dodaje vjerodostojnost vašem profilu i pomaže drugima razumjeti vaše trenačno okruženje.",
      titleHolder: "Nositelj naslova",
      trainingDisciplines: "Trenažne discipline",
      trainingDisciplinesTooltip:
        "Odaberite sve borilačke sportove ili discipline koje aktivno trenirate ili u kojima se natječete. To pomaže u pronalaženju relevantnih prilika i čini vaš profil vidljivijim.",
      weightClasses: "Težinske kategorije",
      weightClassesTooltip:
        "Odaberite težinsku kategoriju u kojoj se trenutno natječete ili ciljate. Ovo je ključno za sparivanje, filtriranje i planiranje događaja.",
      fightStyleDescription: "Opis stila borbe",
      fightStyleDescriptionTooltip:
        "Ukratko opišite svoj borilački pristup, snage i preferirane taktike. To daje menadžerima i organizatorima bolji dojam o vašem načinu borbe.",
    },

    youtubeSection: {
      linkLabel: "YouTube link",
      linkPlaceholder: "npr. https://youtube.com/watch?v=example",
      titleLabel: "Kratki naslov",
      titlePlaceholder: "npr. Najbolji trenuci borbe",
      descriptionLabel: "Kratki opis",
      descriptionPlaceholder:
        "npr. Najzanimljiviji trenuci iz moje posljednje borbe",
      removeButton: "Ukloni link",
      addButton: "Dodaj YouTube link",
      tooltip:
        "Dodajte linkove na svoje borbe, najbolje trenutke ili uvodne videe. Oni pomažu promovirati vaš stil, vještine i iskustvo potencijalnim partnerima ili promotorima.",
    },

    fightHistorySection: {
      title: "Povijest borbi",
      subtitle: "Upravljajte svojom poviješću borbi",
      removeButton: "Ukloni borbu",
      tooltip:
        "Dodajte pojedinosti o svojim prošlim borbama, uključujući protivnika, datum, ishod i lokaciju. To pomaže prikazati vaše iskustvo i povijest nastupa promotorima i organizatorima.",
    },

    achievementsSection: {
      achievementLabel: "Postignuće {{index}}",
      achievementPlaceholder: "npr. Svjetski prvak 2022",
      removeButton: "Ukloni",
      addButton: "Dodaj postignuće",
      tooltip:
        "Navedite svoje najvažnije titule, medalje ili vrhunce karijere. To pomaže izgraditi vaš ugled i pokazuje što ste postigli u borilačkim sportovima.",
    },

    videoUploadSection: {
      title: "Upload videa",
      subtitle: "Učitajte video kako biste prikazali svoje vještine",
      currentVideo: "Trenutni video",
      removeButton: "Ukloni video",
      uploadLabel: "Učitaj video",
      supportedFormats: "Podržani formati: MP4, MOV",
    },

    sponsorshipsSection: {
      title: "Sponzorstvo",
      subtitle: "Prikažite svoje sponzore",
      nameLabel: "Ime sponzora",
      descriptionLabel: "Opis sponzora",
      linkLabel: "Web stranica sponzora",
      logoLabel: "Logo sponzora",
      namePlaceholder: "Ime sponzora",
      descriptionPlaceholder: "Opis sponzora",
      linkPlaceholder: "Link sponzora",
      uploadLogo: "Učitaj logo",
      uploading: "Prenos u tijeku...",
      noSponsorships: "Još nema dodanih sponzora",
      addButton: "Dodaj novog sponzora",
      removeButton: "Ukloni",
      chooseFile: "Odaberite datoteku",
    },

    validation: {
      firstNameRequired: "Ime je obavezno",
      lastNameRequired: "Prezime je obavezno",
      residenceCountryRequired: "Država prebivališta je obavezna",
      nationalityRequired: "Nacionalnost je obavezna",
      phoneDigits: "Telefonski broj smije sadržavati samo znamenke",
      phoneLength: "Telefonski broj mora imati između 10 i 16 znamenki",
      bioLength: "Biografija smije imati najviše 2000 znakova",
      heightRange: "Visina mora biti između {{min}} i {{max}} {{unit}}",
      weightRange: "Težina mora biti između {{min}} i {{max}} {{unit}}",
      reachRange: "Dohvat mora biti između {{min}} i {{max}} {{unit}}",
      videoFormat: "Podržani su samo MP4 i MOV video formati",
      invalidUrl: "Nevažeći URL",
      youtubeDescriptionLength: "Opis smije imati najviše 200 znakova",
      opponentNameLength: "Ime protivnika smije imati najviše 25 znakova",
      fightDateRequired: "Datum je obavezan",
      fightLocationRequired: "Lokacija je obavezna",
      fightResultRequired: "Rezultat je obavezan",
      roundNegative: "Runda ne smije biti negativna",
      typeOfEndingRequired: "Vrsta završetka je obavezna",
      achievementLength: "Postignuće smije imati najviše 5000 znakova",
      sponsorNameLength: "Ime sponzora smije imati najviše 50 znakova",
      sponsorDescriptionLength: "Opis smije imati najviše 500 znakova",
      sponsorNameRequired: "Ime sponzora je obavezno",
      socialMediaUrlRequired: "URL je obavezan",
      socialMediaTypeRequired: "Tip društvenog medija je obavezan",
      invalidSocialMediaUrl: "URL mora početi s http:// ili https://",
      socialMediaTypeUsed: "{{type}} je već korišten",
      formErrors: "Molimo ispravite pogreške u obrascu.",
    },
  },
};
